/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";

import BlogHeader from "components/pageComponents/resources/blogHeader";
import { quote } from "assets/jpg";
// import Image from "next/image";
import RelatedContent from "components/pageComponents/resources/relatedContent";
import { useRouter } from "next/router";
import Seo from "components/Seo";
import Image from "next/image";
import VideoEmbed from "components/videoEmbed";
import Container from "components/sections/container";
import ReactTooltip from "react-tooltip";
import { hyphenate, parseRichTextObjForText, tryJSONdecode } from "utils/utils";
import { Mixpanel } from "utils/mixpanel";
import RichTextSection from "components/sections/richText/richTextSection";
import { getGlobalData, getPageData } from "utils/api";
import { getOneObject, relatedBlogs } from "utils/api/hectare";
//import { useRouter } from "next/router";
//import VideoEmbed from "components/videoEmbed";
const RESOURCES_1 = "/images/png/resources_blog1.png";
const facebook = "/images/png/facebook.png";
const twitter = "/images/png/twitter.png";
const linkedin = "/images/png/linkedin.png";
const link = "/images/png/link.png";

export const QuoteText = ({ data }) => {
  return (
    <div className="flex w-full gap-4">
      <div className="text-xl font-bold text-center">
        <Image
          src={quote}
          width={60}
          height={60}
          layout="fixed"
          alt='"'
          className="self-start"
        />
      </div>
      <p className="text-lg font-bold text-left">{data?.textUrl}</p>
    </div>
  );
};

// TODO: break this file into smaller files

const ClipboardCopy = ({ host, url }) => {
  const [copied, setCopied] = useState({
    message: "copy to clipboard",
    mountToolTip: false,
  });

  useEffect(() => {
    setCopied((prevState) => ({
      ...prevState,
      mountToolTip: !prevState.mountToolTip,
    }));
  }, []);
  return (
    <>
      {copied.mountToolTip && (
        <button
          className="p-2 h-8 w-8 border border-primary hover:bg-primary rounded-[50%] flex items-center justify-center"
          onClick={() => {
            navigator.clipboard.writeText(`${host}${url}`);
            setCopied((prevState) => ({ ...prevState, message: "copied" }));
          }}
          data-tip={copied.message}
          data-for="clipboard"
          onMouseEnter={() => {
            setCopied((prevState) => ({
              ...prevState,
              message: "copy to clipboard",
            }));
          }}
        >
          <img src={link} className="h-4" alt="logo" />
        </button>
      )}
      {copied.mountToolTip && (
        <ReactTooltip
          id="clipboard"
          type="success"
          getContent={() => copied.message}
        />
      )}
    </>
  );
};

const sectionComponents = {
  "sections.rich-text": RichTextSection,
  "sections.large-video": ({ data }) => (
    <Container>
      <Container>
        <VideoEmbed url={data.textUrl} responsive />
      </Container>
    </Container>
  ),
  "sections.large-image": ({ data }) => (
    <Image
      src={data?.image?.data?.attributes?.url}
      width={1000}
      height={500}
      layout="responsive"
      alt={"blog image"}
      className="object-cover object-center"
    />
  ),
};

/** Match each seaction obect (sectionData) with the rendered */
const BlogSection = ({ sectionData }) => {
  // prepare component
  const SectionComponent = sectionComponents[`${sectionData.__component}`];

  if (!SectionComponent) return null;
  // Display section
  return <SectionComponent data={sectionData} />;
};

const Blog = ({ data, related, host, metadata, global }) => {
  const blogAttributes = data?.Blogheader;
  const categoryAttributes = data?.category?.data?.attributes;
  const url = useRouter().asPath;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const trackPageHit = () => {
      Mixpanel.track(`blog/${blogAttributes?.title}`);
    };
    trackPageHit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const metadataWithDefaults = {
    ...global.attributes.metadata,
    ...metadata,
  };
  return (
    <>
      <Seo metadata={metadataWithDefaults} />

      <div className="flex flex-col w-full gap-8 py-4">
        <BlogHeader
          title={blogAttributes?.title}
          date={blogAttributes?.date}
          category={categoryAttributes?.title}
          imgSrc={blogAttributes?.image?.data?.attributes?.url ?? RESOURCES_1}
        />
        {/* TODO: redo this to work like content sections where blogContent is just a section */}
        {data?.Content?.length &&
          data.Content.map((item, index) => {
            return (
              <BlogSection
                key={hyphenate(["blog-section", item.id, "item", index])}
                sectionData={item}
              />
            );
          })}
        <div className="flex justify-center gap-4">
          Share via:
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`https://www.facebook.com/sharer/sharer.php?u=${host}${url}`}
            className="p-2 h-8 w-8 border border-primary hover:bg-primary rounded-[50%] flex items-center justify-center"
          >
            <img src={facebook} className="h-4" alt="logo" />
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`https://twitter.com/intent/tweet?text=${host}${url}`}
            className="p-2 h-8 w-8 border border-primary hover:bg-primary rounded-[50%] flex items-center justify-center"
          >
            <img src={twitter} className="h-[0.8rem]" alt="logo" />
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`http://www.linkedin.com/shareArticle?mini=true&url=${host}${url}`}
            className="p-2 h-8 w-8 border border-primary hover:bg-primary rounded-[50%] flex items-center justify-center"
          >
            <img src={linkedin} className="h-4" alt="logo" />
          </a>
          <ClipboardCopy host={host} url={url} />
        </div>
        {related?.length > 0 && <RelatedContent data={related} />}
      </div>
    </>
  );
};

export default Blog;

export async function getServerSideProps({ params: { slug }, req }) {
  const globalLocale = await getGlobalData("en");
  const pageData = await getPageData({ full_slug: "/resources/hectare" });
  const blogs = await getOneObject("/hectares", slug, {
    category: "*",
    Content: { populate: "*" },
    Blogheader: {
      populate: {
        date: "*",
        title: "*",
        description: "*",
        image: {
          populate: "*",
        },
      },
    },
    keywords: "*",
  });
  const keywordSlug =
    blogs?.data[0]?.attributes?.keywords?.data[0]?.attributes?.slug;
  const related = await relatedBlogs("/keywords", keywordSlug, {
    hectare_blogs: {
      populate: {
        title: "*",
        slug: "*",
        category: "*",
        Blogheader: {
          populate: {
            date: "*",
            image: {
              populate: "*",
            },
          },
        },
      },
    },
  });

  const hectareBlogs = related?.data[0]?.attributes?.hectare_blogs?.data;

  if (!pageData && !blogs) {
    return { props: {} };
  }
  const keywords = blogs?.data[0]?.attributes?.keywords?.data
    .map((item) => item?.attributes?.title)
    .join(",");
  const parseDescription = tryJSONdecode(
    blogs?.data[0]?.attributes?.Blogheader?.description
  );
  const description =
    parseDescription && parseRichTextObjForText(parseDescription);

  const metadata = {
    metaTitle: blogs?.data[0]?.attributes?.Blogheader?.title || null,
    metaDescription:
      description ?? blogs?.data[0]?.attributes?.Blogheader?.description,
    keywords: keywords ?? "thriveagric blog",
  };

  return {
    props: {
      global: globalLocale,
      metadata: metadata,
      host: req?.headers?.host,
      data: blogs?.data[0]?.attributes ?? {},
      related: hectareBlogs ?? [],
      pageData: pageData?.attributes ?? {},
    },
  };
}
